import { render, staticRenderFns } from "./FulfillmentReport.vue?vue&type=template&id=e352fb56&scoped=true"
import script from "./FulfillmentReport.vue?vue&type=script&lang=js"
export * from "./FulfillmentReport.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentReport.vue?vue&type=style&index=0&id=e352fb56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e352fb56",
  null
  
)

export default component.exports